import * as THREE from 'three';

/** Custom event map for PolygonClipVolume drag/drop events */
interface PolygonClipVolumeEventMap extends THREE.Object3DEventMap {
  drag: { type: 'drag'; viewer: PotreeViewer; drag: { end: { x: number; y: number } } };
  drop: { type: 'drop' };
}

/** Minimal Potree viewer interface for drag events */
interface PotreeViewer {
  renderer: THREE.WebGLRenderer;
}

export class PolygonClipVolume extends THREE.Object3D {
  static counter = 0;

  camera: THREE.Camera;
  viewMatrix: THREE.Matrix4;
  projMatrix: THREE.Matrix4;
  markers: THREE.Mesh[];
  initialized: boolean;

  constructor(camera: THREE.Camera) {
    super();

    PolygonClipVolume.counter = PolygonClipVolume.counter + 1;
    this.name = 'polygon_clip_volume_' + PolygonClipVolume.counter;

    this.camera = camera.clone();
    const rotArray = camera.rotation.toArray() as [number, number, number];
    this.camera.rotation.set(rotArray[0], rotArray[1], rotArray[2]);
    this.camera.rotation.order = camera.rotation.order;
    this.camera.updateMatrixWorld();
    (this.camera as THREE.PerspectiveCamera).updateProjectionMatrix?.();
    this.camera.matrixWorldInverse.copy(this.camera.matrixWorld).invert();

    this.viewMatrix = this.camera.matrixWorldInverse.clone();
    this.projMatrix = (this.camera as THREE.PerspectiveCamera).projectionMatrix.clone();

    // projected markers
    this.markers = [];
    this.initialized = false;
  }

  addMarker() {
    const marker = new THREE.Mesh() as THREE.Mesh & THREE.EventDispatcher<PolygonClipVolumeEventMap>;

    const drag = (e: PolygonClipVolumeEventMap['drag']) => {
      const size = e.viewer.renderer.getSize(new THREE.Vector2());
      const projectedPos = new THREE.Vector3(2.0 * (e.drag.end.x / size.width) - 1.0, -2.0 * (e.drag.end.y / size.height) + 1.0, 0);

      marker.position.copy(projectedPos);
    };

    const drop = () => {
      marker.removeEventListener('drag', drag);
      marker.removeEventListener('drop', drop);
    };

    marker.addEventListener('drag', drag);
    marker.addEventListener('drop', drop);

    this.markers.push(marker);
  }

  removeLastMarker() {
    if (this.markers.length > 0) {
      this.markers.splice(this.markers.length - 1, 1);
    }
  }
}
